import { klona as cloneDeep } from 'klona';
import _ from 'lodash';
import {
  SET_AVAILABLE_JOB_USAGE_BUDGET,
  SET_JOB_USAGE_BUDGET_REQUESTS,
  SET_UPDATED_JOB_USAGE_REQUEST_STATUS,
  SET_UPDATED_JOB_USAGE_REQUEST_STATUS_FOR_REQUEST,
  SET_AVAILABLE_USER_BUDGET,
  SET_USER_BUDGET_REQUESTS,
  SET_UPDATED_USER_REQUEST_STATUS_FOR_REQUEST,
  SET_UPDATED_USER_REQUEST_STATUS,
} from '../Actions/ActionCreators/BudgetCappingActionCreator';

const initialState = {
  ByJobId: {},
  JobBudgetCreditRequests: {},
  ByUserId: {},
  UserBudgetCreditRequests: {},
};

function BudgetCappingReducer(state = initialState, action) {
  switch (action.type) {
    case SET_AVAILABLE_JOB_USAGE_BUDGET: {
      return {
        ...state,
        ByJobId: {
          ...state.ByJobId,
          [action.payload.JobId]: action.payload,
        },
      };
    }
    case SET_JOB_USAGE_BUDGET_REQUESTS: {
      const JobBudgetCreditRequests = action.payload.Requests.reduce((acc, request) => {
        acc[request.RequestId] = request;
        return acc;
      }, {});

      return {
        ...state,
        JobBudgetCreditRequests,
        TotalJobBudgetRequests: action.payload.TotalCount,
      };
    }
    case SET_USER_BUDGET_REQUESTS: {
      const UserBudgetCreditRequests = action.payload.Requests.reduce((acc, request) => {
        acc[request.RequestId] = request;
        return acc;
      }, {});

      return {
        ...state,
        UserBudgetCreditRequests,
        TotalUserBudgetRequests: action.payload.TotalCount,
      };
    }
    case SET_UPDATED_JOB_USAGE_REQUEST_STATUS: {
      const jobId = action.payload.JobId;
      return {
        ...state,
        ByJobId: {
          ...state.ByJobId,
          [jobId]: {
            ...state.ByJobId[jobId],
            RequestStatus: action.payload.RequestStatus,
          },
        },
      };
    }
    case SET_UPDATED_USER_REQUEST_STATUS: {
      const userId = action.payload.UserId;
      return {
        ...state,
        ByUserId: {
          ...state.ByUserId,
          [userId]: {
            ...state.ByUserId[userId],
            RequestStatus: action.payload.RequestStatus,
          },
        },
      };
    }
    case SET_UPDATED_JOB_USAGE_REQUEST_STATUS_FOR_REQUEST: {
      const requestId = action.payload.RequestId;
      return {
        ...state,
        JobBudgetCreditRequests: {
          ...state.JobBudgetCreditRequests,
          [requestId]: {
            ...state.JobBudgetCreditRequests[requestId],
            RequestStatus: action.payload.RequestStatus,
            LastAllocatedBudget: action.payload.LastAllocatedBudget,
            CurrentAllocatedBudget: action.payload.CurrentAllocatedBudget,
          },
        },
      };
    }
    case SET_AVAILABLE_USER_BUDGET: {
      return {
        ...state,
        ByUserId: {
          ...state.ByUserId,
          [action.payload.UserId]: action.payload,
        },
      };
    }
    case SET_UPDATED_USER_REQUEST_STATUS_FOR_REQUEST: {
      const requestId = action.payload.RequestId;
      return {
        ...state,
        UserBudgetCreditRequests: {
          ...state.UserBudgetCreditRequests,
          [requestId]: {
            ...state.UserBudgetCreditRequests[requestId],
            RequestStatus: action.payload.RequestStatus,
            LastAllocatedBudget: action.payload.LastAllocatedBudget,
            CurrentAllocatedBudget: action.payload.CurrentAllocatedBudget,
            LastUpdateTime: action.payload.LastUpdateTime,
          },
        },
      };
    }
    default:
      return state;
  }
}

function jobUsageBudgetDataByJobId(state, jobId) {
  return _.get(state, ['BudgetCappingReducer', 'ByJobId', jobId], {});
}

function jobUsageBudgetRequests(state) {
  return _.get(state, ['BudgetCappingReducer', 'JobBudgetCreditRequests'], {});
}

function jobUsageTotalBudgetRequests(state) {
  return _.get(state, ['BudgetCappingReducer', 'TotalJobBudgetRequests'], 0);
}

function userBudgetDataByUserId(state, userId) {
  return _.get(state, ['BudgetCappingReducer', 'ByUserId', userId], {});
}

function userBudgetRequests(state) {
  return _.get(state, ['BudgetCappingReducer', 'UserBudgetCreditRequests'], {});
}

function userTotalBudgetRequests(state) {
  return _.get(state, ['BudgetCappingReducer', 'TotalUserBudgetRequests'], 0);
}

export {
  BudgetCappingReducer,
  jobUsageBudgetDataByJobId,
  jobUsageBudgetRequests,
  jobUsageTotalBudgetRequests,
  userBudgetDataByUserId,
  userBudgetRequests,
  userTotalBudgetRequests,
};
